import { BalanceText } from '@genial/components';
import { Service } from '@genial/services';
import React, { useEffect, useState } from 'react';

import { CustomerTableItemTypes } from '..';

export const CustomerBalance: React.FC<Pick<CustomerTableItemTypes.Props, 'accountSelected'>> = ({
  accountSelected,
}) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [balanceUpdated, setBalanceUpdated] = useState(accountSelected?.balance);
  const [balanceUpdatedAt, setBalanceUpdatedAt] = useState(accountSelected?.balanceUpdatedAt);

  const handleUpdateBalance = () => {
    if (!accountSelected) {
      return;
    }
    setIsUpdating(true);
    Service.Balance.V2.getByAccountNumber({
      screenName: 'Customers',
      accountNumber: accountSelected.accountNumber,
    })
      .then(({ data }) => {
        const availableBalance = data.balance.availableBalance;
        setBalanceUpdated(availableBalance);
        setBalanceUpdatedAt(new Date());
      })
      .finally(() => {
        setIsUpdating(false);
      });
  };

  useEffect(() => {
    setBalanceUpdated(accountSelected?.balance);
    setBalanceUpdatedAt(accountSelected?.balanceUpdatedAt);
  }, [accountSelected]);

  return (
    <BalanceText
      balance={balanceUpdated}
      lastUpdatedAt={balanceUpdatedAt}
      positiveBalanceColor="neutral.dark"
      hasUpdateButton
      isUpdating={isUpdating}
      onUpdateButtonPress={handleUpdateBalance}
      preventBalanceFlex
      containerAlign="flex-start"
      textAlign="center"
    />
  );
};
